<svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
  <g [attr.fill]="color">
    <polygon transform="translate(-1010 -206)translate(323 192)translate(691 20.5)scale(-1 1)translate(-691 -20.5)" points="687 14 687 27 695 20.5"/>
  </g>
</svg>
